import React from 'react';
import moment from 'moment';
import Status from 'components/Molecules/Status/index';
import get from 'lodash/get';
import { Highlight } from 'components/Molecules/Highlight/index';
import { getMomentDate } from 'util/date';

export const TEST_DATA_COL_DEFS = [
  {
    title: 'Export Market',
    dataIndex: 'countryListId',
    render: (value) => {
      if (!value) return 'N/A';
      return value.name;
    },
  },
  {
    title: 'Test Item',
    dataIndex: 'testItemId',
    width: '30%',
    render: (value) => {
      if (!value) return 'N/A';
      return value.data.name;
    },
  },
  {
    title: 'Citation',
    dataIndex: 'testItemId',
    render: (value) => {
      if (!value) return 'N/A';
      const citationName = get(value, 'data.citationList.name');
      return citationName || 'N/A';
    },
  },
  {
    title: 'Issue Party',
    dataIndex: 'serviceProviderId',
    render: (value) => {
      if (!value) return 'N/A';
      return value.data.name;
    },
  },
  {
    title: 'Expiry Date',
    dataIndex: 'expiryDate',
    render: (value) => {
      if (!value) return 'N/A';
      const today = getMomentDate('', true);
      const tMomentVal = moment.isMoment(value) ? value : getMomentDate(value);
      const isRed = tMomentVal.isSameOrBefore(today);

      return (
        <Highlight isHighlight={isRed}>
          {moment.isMoment(value) ? value.format('DD MMM YYYY') : value}
        </Highlight>
      );
    },
  },
  {
    title: 'Test Date / Report Date',
    dataIndex: 'testDate',
    render: (value) => {
      if (!value) return 'N/A';

      return <Highlight>{moment.isMoment(value) ? value.format('DD MMM YYYY') : value}</Highlight>;
    },
  },
  {
    title: 'Result',
    dataIndex: 'result',
    render: (value) => {
      return (
        <Status
          type="text"
          value={value}
          options={[
            {
              key: 'pass',
              label: 'Passed',
              color: 'success',
              icon: null,
            },
            {
              key: 'fail',
              label: 'Failed',
              color: 'error',
              icon: null,
            },
          ]}
        />
      );
    },
  },
];

export const CERTIFICATE_DATA_COL_DEFS = [
  {
    title: 'Type',
    dataIndex: 'certificateTypeId',
    render: (value) => {
      if (!value) return 'N/A';
      return value.data.name;
    },
  },
  {
    title: 'Score / Overall Rating',
    dataIndex: 'customCertificateScoreId',
    render: (value) => {
      if (!value) return 'N/A';
      return value.data.name;
    },
  },
  {
    title: 'Issue Party',
    dataIndex: 'customIssuePartyId',
    render: (value) => {
      if (!value) return 'N/A';
      return value.data.name;
    },
  },
  {
    title: 'Expiry Date',
    dataIndex: 'expiryDate',
    render: (value) => {
      if (!value) return 'N/A';
      const today = getMomentDate('', true);
      const tMomentVal = moment.isMoment(value) ? value : getMomentDate(value);
      const isRed = !!tMomentVal && tMomentVal.isSameOrBefore(today);

      return (
        <Highlight isHighlight={isRed}>
          {moment.isMoment(value) ? value.format('DD MMM YYYY') : value}
        </Highlight>
      );
    },
  },
  {
    title: 'Certificate Date / Report Date',
    dataIndex: 'testDate',
    render: (value) => {
      if (!value) return 'N/A';

      return <Highlight>{moment.isMoment(value) ? value.format('DD MMM YYYY') : value}</Highlight>;
    },
  },
];
export const OTHER_DATA_COL_DEFS = [
  {
    title: 'Type',
    dataIndex: 'customComplianceOtherDataTypeId',
    render: (value) => {
      if (!value) return 'N/A';
      return value.data.name;
    },
  },
  {
    title: 'Name',
    dataIndex: 'name',
    render: (value) => {
      if (!value) return '/';
      return value;
    },
  },
  {
    title: 'Description',
    dataIndex: 'description',
    render: (value) => {
      if (!value) return '/';
      return value;
    },
  },
  {
    title: 'Issue Party',
    dataIndex: 'customIssuePartyId',
    render: (value) => {
      if (!value) return 'N/A';
      return value.data.name;
    },
  },
  {
    title: 'Expiry Date',
    dataIndex: 'expiryDate',
    render: (value) => {
      if (!value) return 'N/A';
      const today = getMomentDate('', true);
      const tMomentVal = moment.isMoment(value) ? value : getMomentDate(value);
      const isRed = tMomentVal.isSameOrBefore(today);

      return (
        <Highlight isHighlight={isRed}>
          {moment.isMoment(value) ? value.format('DD MMM YYYY') : value}
        </Highlight>
      );
    },
  },
  {
    title: 'Issue Date',
    dataIndex: 'testDate',
    render: (value) => {
      if (!value) return 'N/A';

      return <Highlight>{moment.isMoment(value) ? value.format('DD MMM YYYY') : value}</Highlight>;
    },
  },
  {
    title: 'Result',
    dataIndex: 'result',
    render: (value) => {
      return (
        <Status
          type="text"
          value={value}
          options={[
            {
              key: 'pass',
              label: 'Passed',
              color: 'success',
              icon: null,
            },
            {
              key: 'fail',
              label: 'Failed',
              color: 'error',
              icon: null,
            },
            {
              key: 'notAvailable',
              label: 'N/A',
              color: 'default',
            },
          ]}
        />
      );
    },
  },
];
